var _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect4, _polygon6, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPA6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.6.1",
    x: 261,
    y: 379,
    width: 86,
    height: 122
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.6.2",
    x: 115,
    y: 379,
    width: 141.07,
    height: 122
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.6.3",
    x: 104,
    y: 190,
    width: 126,
    height: 185
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.6.4",
    points: "233.99 190 347 190 347 341 259.01 341 259.01 330 233.99 330 233.99 190"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.6.5",
    points: "352 207 464 207 464 330 440 330 440 341 352 341 352 207"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.6.6",
    points: "469.01 207 582 207 582 341 492.93 341 492.93 330 469.01 330 469.01 207"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.6.7",
    points: "585.93 207 699 207 699 330 674 330 674 341 585.93 341 585.93 207"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.6.8",
    points: "703 219 874 219 874 375 797 375 797 341 703 341 703 219"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.6.9",
    x: 703,
    y: 379,
    width: 183,
    height: 151
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.6.10",
    points: "698.99 379 698.99 513 586 513 586 389 611 389 611 379 698.99 379"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.6.11",
    points: "582 389 582 513 469 513 469 379 557 379 557 389 582 389"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgCiAgICB2aWV3Qm94PSIwIDAgOTkwIDcyMCIKPgogICAgPHJlY3QgZGF0YS1pZD0iQS42LjEiIHg9IjI2MSIgeT0iMzc5IiB3aWR0aD0iODYiIGhlaWdodD0iMTIyIi8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjYuMiIgeD0iMTE1IiB5PSIzNzkiIHdpZHRoPSIxNDEuMDciIGhlaWdodD0iMTIyIi8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjYuMyIgeD0iMTA0IiB5PSIxOTAiIHdpZHRoPSIxMjYiIGhlaWdodD0iMTg1Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjYuNCIgcG9pbnRzPSIyMzMuOTkgMTkwIDM0NyAxOTAgMzQ3IDM0MSAyNTkuMDEgMzQxIDI1OS4wMSAzMzAgMjMzLjk5IDMzMCAyMzMuOTkgMTkwIi8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjYuNSIgcG9pbnRzPSIzNTIgMjA3IDQ2NCAyMDcgNDY0IDMzMCA0NDAgMzMwIDQ0MCAzNDEgMzUyIDM0MSAzNTIgMjA3Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjYuNiIgcG9pbnRzPSI0NjkuMDEgMjA3IDU4MiAyMDcgNTgyIDM0MSA0OTIuOTMgMzQxIDQ5Mi45MyAzMzAgNDY5LjAxIDMzMCA0NjkuMDEgMjA3Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjYuNyIgcG9pbnRzPSI1ODUuOTMgMjA3IDY5OSAyMDcgNjk5IDMzMCA2NzQgMzMwIDY3NCAzNDEgNTg1LjkzIDM0MSA1ODUuOTMgMjA3Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjYuOCIgcG9pbnRzPSI3MDMgMjE5IDg3NCAyMTkgODc0IDM3NSA3OTcgMzc1IDc5NyAzNDEgNzAzIDM0MSA3MDMgMjE5Ii8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjYuOSIgeD0iNzAzIiB5PSIzNzkiIHdpZHRoPSIxODMiIGhlaWdodD0iMTUxIi8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjYuMTAiIHBvaW50cz0iNjk4Ljk5IDM3OSA2OTguOTkgNTEzIDU4NiA1MTMgNTg2IDM4OSA2MTEgMzg5IDYxMSAzNzkgNjk4Ljk5IDM3OSIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS42LjExIiBwb2ludHM9IjU4MiAzODkgNTgyIDUxMyA0NjkgNTEzIDQ2OSAzNzkgNTU3IDM3OSA1NTcgMzg5IDU4MiAzODkiLz4KPC9zdmc+";
export { SvgPA6 as ReactComponent };